import { render } from "./ReviweEducationReform.vue?vue&type=template&id=583410d7&scoped=true"
import script from "./ReviweEducationReform.vue?vue&type=script&lang=js"
export * from "./ReviweEducationReform.vue?vue&type=script&lang=js"

import "./ReviweEducationReform.vue?vue&type=style&index=0&id=583410d7&scoped=true&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583410d7"]])

export default __exports__